import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/shared/PageHeader';

export function SettingsPage() {
    const { t } = useTranslation();
    return (
        <>
            <PageHeader title={t('settings.title')} subtitle={t('settings.subtitle')} />
            <Box sx={{ p: 3 }}>
                <Typography>{t('settings.placeholder')}</Typography>
            </Box>
        </>
    );
}
